import { Component, computed, output, signal } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { faSolidArrowsLeftRight } from '@ng-icons/font-awesome/solid';

@Component({
    selector: 'app-glossary-language-switch',
    imports: [NgIcon],
    providers: [provideIcons({ faSolidArrowsLeftRight })],
    templateUrl: './glossary-language-switch.component.html',
    styleUrl: './glossary-language-switch.component.scss'
})
export class GlossaryLanguageSwitchComponent {
  protected primary = signal<'en' | 'de'>('en');
  protected secondary = computed(() => this.primary() === 'en' ? 'de' : 'en');
  protected primaryText = computed(() => this.primary() === 'de'? 'deutsch' : 'englisch');
  protected secondaryText = computed(() => this.secondary() === 'de'? 'deutsch' : 'englisch');
  protected update = output<'en' | 'de'>();

  protected switch() {
    this.primary.set(this.secondary());
    this.update.emit(this.primary());
  }
}
